import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		// Variables
		const sections = document.querySelectorAll(".content-gallery-carousel")

		// Initializing Splider
		for (let i = 0; i < sections.length; i++) {
			let slider = sections[i].querySelector(".gallery-slider")
			let thumbSlider = sections[i].querySelector(".thumbnails-slider")

			if(!thumbSlider) {
				new Splide(slider, {
					type: "slide",
					arrows: true,
					pagination: true,
					padding: "2rem",
					gap: "1.5rem",
					perPage: 2,
					breakpoints: {
						1023: {
							padding: "1.5rem",
							gap: "1rem",
							perPage: 1
						}
					}
				}).mount()
			} else {
				let thumbSplide = new Splide( thumbSlider, {
					fixedWidth: 100,
					fixedHeight: 60,
					arrows: false,
					gap: 10,
					rewind: true,
					pagination: false,
					focus: 'center',
					isNavigation: true,
					breakpoints: {
					  600: {
						fixedWidth: 60,
						fixedHeight: 44
					  },
					},
				})

				let mainSplide = new Splide(slider, {
					type: "slide",
					arrows: true,
					pagination: false,
					padding: "2rem",
					gap: "1.5rem",
					perPage: 2,
					breakpoints: {
						1023: {
							padding: "1.5rem",
							gap: "1rem",
							perPage: 1
						}
					}
				})

				mainSplide.sync( thumbSplide )
				mainSplide.mount()
				thumbSplide.mount()
			}
		}
	})
	.catch((err) => {
		console.error(err)
	});